interface Language {
  code: string;
  name: string;
  native: string;
}

export const languages: Language[] = [
  { code: 'en', name: 'English', native: 'English' },
  { code: 'zh', name: 'Chinese (Simplified)', native: '简体中文' },
  { code: 'zh-tw', name: 'Chinese (Traditional)', native: '繁體中文' },
  { code: 'es', name: 'Spanish', native: 'Español' },
  { code: 'hi', name: 'Hindi', native: 'हिन्दी' },
  { code: 'ar', name: 'Arabic', native: 'العربية' },
  { code: 'pt', name: 'Portuguese', native: 'Português' },
  { code: 'bn', name: 'Bengali', native: 'বাংলা' },
  { code: 'ru', name: 'Russian', native: 'Русский' },
  { code: 'ja', name: 'Japanese', native: '日本語' },
  { code: 'pa', name: 'Punjabi', native: 'ਪੰਜਾਬੀ' },
  { code: 'de', name: 'German', native: 'Deutsch' },
  { code: 'jv', name: 'Javanese', native: 'ꦧꦱꦗꦮ' },
  { code: 'wo', name: 'Wolof', native: 'Wolof' },
  { code: 'ms', name: 'Malay', native: 'Bahasa Melayu' },
  { code: 'te', name: 'Telugu', native: 'తెలుగు' },
  { code: 'vi', name: 'Vietnamese', native: 'Tiếng Việt' },
  { code: 'ko', name: 'Korean', native: '한국어' },
  { code: 'fr', name: 'French', native: 'Français' },
  { code: 'mr', name: 'Marathi', native: 'मराठी' },
  { code: 'ta', name: 'Tamil', native: 'தமிழ்' },
  { code: 'ur', name: 'Urdu', native: 'اردو' },
  { code: 'tr', name: 'Turkish', native: 'Türkçe' },
  { code: 'it', name: 'Italian', native: 'Italiano' },
  { code: 'th', name: 'Thai', native: 'ไทย' },
  { code: 'gu', name: 'Gujarati', native: 'ગુજરાતી' },
  { code: 'jin', name: 'Jin Chinese', native: '晉語' },
  { code: 'pl', name: 'Polish', native: 'Polski' },
  { code: 'kn', name: 'Kannada', native: 'ಕನ್ನಡ' },
  { code: 'mai', name: 'Maithili', native: 'मैथिली' },
  { code: 'my', name: 'Burmese', native: 'မြန်မာစာ' },
  { code: 'shn', name: 'Shan', native: 'လိၵ်ႈတႆး' },
  { code: 'xh', name: 'Xhosa', native: 'isiXhosa' },
  { code: 'zu', name: 'Zulu', native: 'isiZulu' },
  { code: 'yo', name: 'Yoruba', native: 'Yorùbá' },
  { code: 'so', name: 'Somali', native: 'Soomaaliga' },
  { code: 'ceb', name: 'Cebuano', native: 'Binisayâ' },
  { code: 'nl', name: 'Dutch', native: 'Nederlands' },
  { code: 'ku', name: 'Kurdish', native: 'Kurdî' },
  { code: 'or', name: 'Odia', native: 'ଓଡ଼ିଆ' },
  { code: 'sa', name: 'Sanskrit', native: 'संस्कृतम्' },
  { code: 'ne', name: 'Nepali', native: 'नेपाली' },
  { code: 'si', name: 'Sinhala', native: 'සිංහල' },
  { code: 'ro', name: 'Romanian', native: 'Română' },
  { code: 'rw', name: 'Kinyarwanda', native: 'Ikinyarwanda' },
  { code: 'mg', name: 'Malagasy', native: 'Malagasy' },
  { code: 'ig', name: 'Igbo', native: 'Igbo' },
  { code: 'ny', name: 'Chichewa', native: 'Chichewa' },
  { code: 'ha', name: 'Hausa', native: 'هَرْشَن هَوْسَ' },
  { code: 'uz', name: 'Uzbek', native: 'Oʻzbekcha' },
  { code: 'am', name: 'Amharic', native: 'አማርኛ' },
  { code: 'ug', name: 'Uyghur', native: 'ئۇيغۇرچە' },
  { code: 'sd', name: 'Sindhi', native: 'سنڌي' },
  { code: 'su', name: 'Sundanese', native: 'Basa Sunda' },
  { code: 'hm', name: 'Hmong', native: 'Hmoob' },
  { code: 'sh', name: 'Serbo-Croatian', native: 'Srpskohrvatski' },
  { code: 'rn', name: 'Rundi', native: 'Kirundi' },
  { code: 'cs', name: 'Czech', native: 'Čeština' },
  { code: 'hu', name: 'Hungarian', native: 'Magyar' },
  { code: 'be', name: 'Belarusian', native: 'беларуская' },
  { code: 'gr', name: 'Greek', native: 'Ελληνικά' },
  { code: 'sv', name: 'Swedish', native: 'Svenska' },
  { code: 'he', name: 'Hebrew', native: 'עברית' },
  { code: 'as', name: 'Assamese', native: 'অসমীয়া' },
  { code: 'bg', name: 'Bulgarian', native: 'български' },
  { code: 'ka', name: 'Georgian', native: 'ქართული' },
  { code: 'az', name: 'Azerbaijani', native: 'azərbaycan dili' },
  { code: 'sl', name: 'Slovene', native: 'Slovenščina' },
  { code: 'ca', name: 'Catalan', native: 'Català' },
  { code: 'fi', name: 'Finnish', native: 'Suomi' },
  { code: 'hy', name: 'Armenian', native: 'Հայերեն' },
  { code: 'lv', name: 'Latvian', native: 'latviešu valoda' },
  { code: 'hr', name: 'Croatian', native: 'Hrvatski' },
  { code: 'no', name: 'Norwegian', native: 'Norsk' },
  { code: 'et', name: 'Estonian', native: 'eesti keel' },
  { code: 'lt', name: 'Lithuanian', native: 'lietuvių kalba' },
  { code: 'sk', name: 'Slovak', native: 'slovenčina' },
  { code: 'da', name: 'Danish', native: 'Dansk' },
  { code: 'bs', name: 'Bosnian', native: 'bosanski jezik' },
  { code: 'sq', name: 'Albanian', native: 'Shqip' },
  { code: 'is', name: 'Icelandic', native: 'íslenska' },
  { code: 'fa', name: 'Persian', native: 'فارسی' },
  { code: 'ga', name: 'Irish', native: 'Gaeilge' },
  { code: 'mk', name: 'Macedonian', native: 'македонски јазик' },
  { code: 'mt', name: 'Maltese', native: 'Malti' },
  { code: 'cy', name: 'Welsh', native: 'Cymraeg' },
  { code: 'eu', name: 'Basque', native: 'euskera' },
  { code: 'gl', name: 'Galician', native: 'Galego' },
  { code: 'lb', name: 'Luxembourgish', native: 'Lëtzebuergesch' },
  { code: 'af', name: 'Afrikaans', native: 'Afrikaans' },
  { code: 'sw', name: 'Swahili', native: 'Kiswahili' },
  { code: 'tn', name: 'Tswana', native: 'Setswana' },
  { code: 've', name: 'Venda', native: 'Tshivenḓa' },
  { code: 'ts', name: 'Tsonga', native: 'Xitsonga' },
  { code: 'ss', name: 'Swati', native: 'SiSwati' },
  { code: 'st', name: 'Southern Sotho', native: 'Sesotho' },
  { code: 'nso', name: 'Northern Sotho', native: 'Sepedi' },
  { code: 'nr', name: 'Southern Ndebele', native: 'isiNdebele' },
  { code: 'nd', name: 'Northern Ndebele', native: 'isiNdebele' },
  { code: 'lo', name: 'Lao', native: 'ພາສາລາວ' },
  { code: 'km', name: 'Khmer', native: 'ភាសាខ្មែរ' },
  { code: 'mn', name: 'Mongolian', native: 'монгол' },
  { code: 'bo', name: 'Tibetan', native: 'བོད་ཡིག' },
  { code: 'dz', name: 'Dzongkha', native: 'རྫོང་ཁ' },
  { code: 'ii', name: 'Nuosu', native: 'ꆈꌠ꒿' },
  { code: 'chr', name: 'Cherokee', native: 'ᏣᎳᎩ ᎦᏬᏂᎯᏍᏗ' },
  { code: 'iu', name: 'Inuktitut', native: 'ᐃᓄᒃᑎᑐᑦ' },
  { code: 'ojw', name: 'Ojibwe', native: 'ᐊᓂᔑᓈᐯᒧᐎᓐ' },
  { code: 'cr', name: 'Cree', native: 'ᓀᐦᐃᔭᐍᐏᐣ' },
  { code: 'ik', name: 'Inupiaq', native: 'Iñupiatun' },
  { code: 'ber', name: 'Berber', native: 'ⵜⴰⵎⴰⵣⵉⵖⵜ' },
  { code: 'ti', name: 'Tigrinya', native: 'ትግርኛ' },
  { code: 'om', name: 'Oromo', native: 'Afaan Oromoo' },
  { code: 'ak', name: 'Akan', native: 'Akan' },
  { code: 'tw', name: 'Twi', native: 'Twi' },
  { code: 'ee', name: 'Ewe', native: 'Eʋegbe' },
  { code: 'ff', name: 'Fulah', native: 'Fulfulde' },
  { code: 'lg', name: 'Ganda', native: 'Luganda' },
  { code: 'ki', name: 'Kikuyu', native: 'Gĩkũyũ' },
  { code: 'ln', name: 'Lingala', native: 'Lingála' },
  { code: 'lua', name: 'Luba-Lulua', native: 'Kiluba' },
  { code: 'lu', name: 'Luba-Katanga', native: 'Kiluba' },
  { code: 'sg', name: 'Sango', native: 'Sängö' },
  { code: 'bm', name: 'Bambara', native: 'bamanankan' },
  { code: 'dyu', name: 'Dyula', native: 'Dyula' },
  { code: 'man', name: 'Mandingo', native: 'Mandingo' },
  { code: 'snk', name: 'Soninke', native: 'Soninke' },
  { code: 'kri', name: 'Krio', native: 'Krio' },
  { code: 'tpi', name: 'Tok Pisin', native: 'Tok Pisin' },
  { code: 'bi', name: 'Bislama', native: 'Bislama' },
  { code: 'hil', name: 'Hiligaynon', native: 'Hiligaynon' },
  { code: 'ilo', name: 'Ilocano', native: 'Ilocano' },
  { code: 'pag', name: 'Pangasinan', native: 'Pangasinan' },
  { code: 'war', name: 'Waray-Waray', native: 'Waray-Waray' },
  { code: 'pam', name: 'Kapampangan', native: 'Kapampangan' },
  { code: 'bcl', name: 'Central Bikol', native: 'Bikol Sentral' },
  { code: 'tl', name: 'Filipino', native: 'Filipino' },
  { code: 'ckb', name: 'Central Kurdish', native: 'کوردی' },
  { code: 'kmr', name: 'Northern Kurdish', native: 'Kurmancî' },
  { code: 'lrc', name: 'Northern Luri', native: 'لۊری شومالی' },
  { code: 'mzn', name: 'Mazanderani', native: 'مازِرونی' },
  { code: 'glk', name: 'Gilaki', native: 'گیلکی' },
  { code: 'ps', name: 'Pashto', native: 'پښتو' },
  { code: 'bal', name: 'Balochi', native: 'بلۏچی' },
  { code: 'bh', name: 'Bihari', native: 'भोजपुरी' },
  { code: 'mag', name: 'Magahi', native: 'मगही' },
  { code: 'new', name: 'Newari', native: 'नेपाल भाषा' },
  { code: 'gom', name: 'Konkani', native: 'कोंकणी' },
  { code: 'sat', name: 'Santali', native: 'ᱥᱟᱱᱛᱟᱲᱤ' },
  { code: 'bho', name: 'Bhojpuri', native: 'भोजपुरी' },
  { code: 'kok', name: 'Konkani', native: 'कोंकणी' },
  { code: 'brx', name: 'Bodo', native: 'बर\'' },
  { code: 'mni', name: 'Manipuri', native: 'মৈতৈলোন্' },
  { code: 'dv', name: 'Dhivehi', native: 'ދިވެހިބަސް' },
  { code: 'id', name: 'Indonesian', native: 'Bahasa Indonesia' },
  { code: 'mad', name: 'Madurese', native: 'Basa Madhura' },
  { code: 'min', name: 'Minangkabau', native: 'Baso Minangkabau' },
  { code: 'bug', name: 'Buginese', native: 'ᨅᨔ ᨕᨘᨁᨗ' },
  { code: 'mak', name: 'Makasar', native: 'ᨅᨔ ᨆᨀᨔᨑ' },
  { code: 'ban', name: 'Balinese', native: 'ᬩᬲᬩᬮᬶ' },
  { code: 'bjn', name: 'Banjar', native: 'Bahasa Banjar' },
  { code: 'ace', name: 'Acehnese', native: 'Basa Acèh' },
  { code: 'tet', name: 'Tetum', native: 'tetun' },
  { code: 'ch', name: 'Chamorro', native: 'Fino\' Chamoru' },
  { code: 'pau', name: 'Palauan', native: 'Tekoi ra Belau' },
  { code: 'mh', name: 'Marshallese', native: 'Kajin M̧ajeļ' },
  { code: 'gil', name: 'Gilbertese', native: 'taetae ni kiribati' },
  { code: 'na', name: 'Nauruan', native: 'Dorerin Naoero' },
  { code: 'tvl', name: 'Tuvaluan', native: 'Te ggana Tuuvalu' },
  { code: 'to', name: 'Tongan', native: 'faka Tonga' },
  { code: 'sm', name: 'Samoan', native: 'gagana fa\'a Samoa' },
  { code: 'fj', name: 'Fijian', native: 'vosa Vakaviti' },
  { code: 'mi', name: 'Maori', native: 'te reo Māori' },
  { code: 'haw', name: 'Hawaiian', native: 'ʻŌlelo Hawaiʻi' },
  { code: 'ty', name: 'Tahitian', native: 'Reo Tahiti' }
];
